import noopFunctionUtil from 'utils/functions/noop'
import React from 'react'
import P from 'components/P'
import SidebarFooter from 'containers/Sidebar/components/Footer'
import ButtonPrimary from 'components/ButtonPrimary'
import CheckmarkIcon from 'components/Icons/Checkmark'
import useSelector from 'hooks/use-selector'
import hasVariantByIdInCartSelector from 'modules/cart/redux/selectors/has-variant-by-id-in-cart'
import getByVariantIdAddLabelSelector from 'modules/product/redux/selectors/get-by-variant-id-add-label'
import logUtil from 'utils/log'
import toggleAddRemoveProductCartAction from 'modules/cart/redux/actions/toggle-add-remove'
import useDispatch from 'hooks/use-dispatch'
import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'
import startGiftingModeGiftAction from 'modules/gift/redux/actions/start-gifting-mode'
import TextError from 'components/TextError'
import isCurrentVariantAFullSizeProductSelect from 'modules/gift/redux/selectors/is-current-variant-a-full-size'
import getAmountGiftSelect from 'modules/gift/redux/selectors/get-amount'
import { GIFT_CARD_AMOUNT_TO_VARIANT_ID } from 'modules/gift/constants'
import deleteGiftCardGiftAction from 'modules/gift/redux/actions/delete-gift-card'
import getGiftCardItemCartSelect from 'modules/cart/redux/selectors/get-gift-card'
import loadInfoVariantAction from 'modules/variant/redux/actions/load-info'
import isGiftUrlLocationUtil from 'utils/location/is-gift-url'
import Flex from 'components/Flex'
import useIsSmallScreen from 'hooks/use-is-small-screen'
import getDiscountPercentageFromVariantInfoSelector from 'modules/variant/redux/selectors/get-discount-percentage-from-variant-info'
import isDisabledQuickShopProductButtonSelector from 'containers/QuickShopProductSidebar/components/Button/selectors/is-disabled'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import getDiscountDataSelectorProductCollectionItemSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-discount-data'
import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import getSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-subscription-selling-plan-id'
import hasSubscriptionsVariantProductSelector from 'modules/product/redux/selectors/has-subscriptions'
import QuickShopProductSidebarSubscribeAndSaveCheckbox from 'containers/QuickShopProductSidebar/components/Button/components/SubscribeAndSaveCheckbox'
import isSelectedVariantOutOfStockVariantSelect from 'modules/variant/redux/selectors/is-selected-variant-out-of-stock'
import getPriceProductVariantUtil from 'modules/product-variant/utils/get-price'
import QuickShopProductSidebarButtonHandleRating from 'containers/QuickShopProductSidebar/components/QuickShopProductSidebarButtonHandleRating'
import isFullSizeFromConversionOutOfStockSelector from 'containers/ProductCollection/components/Item/redux/selectors/is-full-size-from-conversion-out-of-stock'
import LoadFullSizeVariantToBeRated from 'containers/ProductCollection/components/Item/components/LoadFullSizeVariantToBeRated'
import isFullSizeDiscountVariantUtil from 'modules/variant/utils/is-full-size-discount'
import useIsExtraExtraSmallScreen from 'hooks/use-is-extra-extra-small-screen'
import openAddFullSizeAfterRatingModalProductionAction from 'modules/product/redux/actions/open-add-full-size-after-rating-modal'
import { shouldShowAOVLockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-lock'
import ProductAOVLockProgressBar from 'containers/QuickShopProductSidebar/components/Button/components/ProductAOVLockProgressBar'
import { shouldShowAOVUnlockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-unlock'
import ProductAOVUnlockProgressBar from 'containers/QuickShopProductSidebar/components/Button/components/ProductAOVUnlockProgressBar'

const FULL_SIZE_DISCOUNT_ALERT_TEXT = 'This product will automatically be added to your order when you add a sample to your cart.'

const ANALYTICS_EVENT = {
  RATE_SAMPLED_VARIANT_FROM_QUICK_SHOP: 'RATE_SAMPLED_VARIANT_FROM_QUICK_SHOP'
}

const ADD_TO_CART = 'Add to Cart'

/**
 *
 * @param props
 * @param props.hasExpressCheckout
 * @param props.shouldShowEditRating
 * @param props.needsToBeRatedSample
 * @param {ProductVariantCollection} props.productVariant
 * @param props.isGiftCard
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarButton (props) {
  const dispatch = useDispatch()
  const {
    hasExpressCheckout,
    needsToBeRatedSample,
    shouldShowEditRating,
    isFromProductPage = false,
    showStrikethroughPricing = false
  } = props
  /**
   * @type {ProductVariantCollection}
   */
  const productVariant = props.productVariant
  const isFullSizeDiscount = isFullSizeDiscountVariantUtil(productVariant)
  const isGiftCard = props.isGiftCard
  const variantIdState = (
    useSelector(getSelectedColorVariantIdVariantSelect) ||
    productVariant?.variant_id
  )
  const isFullSize = useSelector(isCurrentVariantAFullSizeProductSelect)
  const [error, setError] = React.useState()
  const [isLoading, setIsLoading] = React.useState()
  const amount = useSelector(getAmountGiftSelect)
  const variantId = isGiftCard
    ? GIFT_CARD_AMOUNT_TO_VARIANT_ID[amount]
    : variantIdState
  const isInCart = useSelector(hasVariantByIdInCartSelector(variantId))
  const isOutOfStock = useSelector(isSelectedVariantOutOfStockVariantSelect)
  const selectedVariant = useSelector(getSelectedVariantSelect)
  const [isBottomSheetOpen, setIsBottomSheetOpen] = React.useState(false)
  const priceStr = getPriceProductVariantUtil(selectedVariant)
  let price = priceStr ? parseFloat(priceStr) : null
  const discountPercentage = useSelector(getDiscountPercentageFromVariantInfoSelector({ variantId }))
  const hasSampled = useSelector(hasSampledVariantSelector(variantId))
  const hasSubscriptions = useSelector(hasSubscriptionsVariantProductSelector(variantId))

  const {
    discountPrice
  } = useSelector(
    getDiscountDataSelectorProductCollectionItemSelector({
      discountPercentage,
      isFullSize,
      price,
      productVariant,
      variantId
    })
  )

  if (
    discountPercentage !== 100 &&
    discountPrice &&
    discountPrice !== price
  ) {
    price = discountPrice
  }

  if (discountPercentage === 100) {
    price = 0
  }

  const giftCardItem = useSelector(getGiftCardItemCartSelect)
  const isSmallScreen = useIsSmallScreen()
  const isExtraExtraSmallScreen = useIsExtraExtraSmallScreen()
  const label = useSelector(
    getByVariantIdAddLabelSelector({
      variantId,
      isLoading,
      price,
      isFromSidebar: true,
      isGiftCard,
      hasExpressCheckout,
      isSmallScreen,
      needsToBeRatedSample,
      isExtraExtraSmallScreen
    })
  )

  const aovLock = productVariant?.aov_lock
  const shouldShowAovLock = useSelector(shouldShowAOVLockProductVariantSelector({ productVariant }))
  const shouldShowAovUnlock = useSelector(shouldShowAOVUnlockProductVariantSelector({ productVariant }))
  const hasSelectedVariant = !!selectedVariant
  const subscriptionSellingPlanId = useSelector(getSubscriptionSellingPlanIdVariantSelector(variantId))
  const isFullSizeOutOfStock = useSelector(isFullSizeFromConversionOutOfStockSelector({ productVariant }))
  const notDeliveredYet = hasSampled && !needsToBeRatedSample
  const isDisabled = useSelector(
    isDisabledQuickShopProductButtonSelector({
      isGiftCard,
      needsToBeRatedSample,
      shouldShowAovLock,
      notDeliveredYet,
      isFullSizeDiscount
    })
  )

  const debugProps = {
    label,
    price,
    amount,
    isInCart,
    isGiftCard,
    variantId,
    isDisabled,
    props,
    subscriptionSellingPlanId,
    isOutOfStock,
    selectedVariant,
    hasSelectedVariant,
    discountPercentage,
    discountPrice,
    isFullSizeDiscount
  }

  logUtil('QuickShopProductSidebarButton').debug('debugProps=', debugProps)

  React.useEffect(() => {
    dispatch(
      loadInfoVariantAction({
        productId: productVariant.product_id,
        variantId,
        variantPrice: price,
        variantSku: productVariant.sku
      })
    )
  }, [variantId])

  const handleCloseRating = () => setIsBottomSheetOpen(false)

  const openAddFullSizeModal = () => {
    if (isFullSizeOutOfStock) {
      return
    }

    dispatch(
      openAddFullSizeAfterRatingModalProductionAction({
        imageUrl: productVariant.variant_image_url,
        productVariant
      })
    )
  }

  const handleClick = async () => {
    logUtil('QuickShopProductSidebarButton#handleClick').debug('[start]')

    if (
      needsToBeRatedSample &&
      hasSampled
    ) {
      // only allow rating when sample is sampled & delivered
      logEventAnalyticsUtil(ANALYTICS_EVENT.RATE_SAMPLED_VARIANT_FROM_QUICK_SHOP)
      setIsBottomSheetOpen(true)
      return
    }

    if (isGiftUrlLocationUtil()) {
      dispatch(startGiftingModeGiftAction())
    }

    if (
      isGiftCard &&
      giftCardItem?.variant_id !== variantId
    ) {
      await dispatch(deleteGiftCardGiftAction())
    }

    if (
      !isInCart &&
      props?.beforeOnClickAdd?.() === false
    ) {
      logUtil('QuickShopProductSidebarButton#handleClick').debug('[noop] beforeOnClickAdd')
      return
    }

    const res = await dispatch(
      toggleAddRemoveProductCartAction({
        setIsLoading,
        variantId,
        productVariant: selectedVariant,
        subscriptionSellingPlanId,
        shouldShowFullSizeConversion: shouldShowEditRating
      })
    )

    // if (res?.wasAdded) {
    //   dispatch(
    //     suggestOtherColorOrCloseSidebarProductAction({
    //       justAddedVariantId: variantId
    //     })
    //   )
    // }

    if (res?.error) {
      setError(res.error)
    }
  }

  const labelToUse = showStrikethroughPricing ? ADD_TO_CART : label

  const onClick = isLoading
    ? noopFunctionUtil
    : handleClick
  // const onClick = handleClick

  const element = (
    <>
      <QuickShopProductSidebarButtonHandleRating
        productVariant={productVariant}
        variantId={variantId}
        onClose={handleCloseRating}
        openAddFullSizeModal={openAddFullSizeModal}
        isBottomSheetOpen={isBottomSheetOpen}
      />

      {
        !!error && (
          <TextError>{error}</TextError>
        )
      }

      {
        !isFromProductPage &&
        hasSubscriptions && (
          <QuickShopProductSidebarSubscribeAndSaveCheckbox
            variantId={variantId}
          />
        )
      }

      <LoadFullSizeVariantToBeRated
        productVariant={productVariant}
        needsToBeRatedSample={needsToBeRatedSample}
      />

      {
        isFullSizeDiscount && (
          <P className='full-size-discount-alert-text'>
            {FULL_SIZE_DISCOUNT_ALERT_TEXT}
          </P>
        )
      }

      {
        !!shouldShowAovLock && (
          <ProductAOVLockProgressBar
            aovLock={aovLock}
          />
        )
      }

      {
        !!shouldShowAovUnlock && (
          <ProductAOVUnlockProgressBar
            aovLock={aovLock}
          />
        )
      }

      <Flex
        className='quick-shop-product-sidebar-cart-buttons'
      >
        <ButtonPrimary
          disabled={isDisabled}
          onClick={onClick}
          className='quick-shop-product-sidebar-cart-button'
        >
          {
            isInCart && (
              <CheckmarkIcon />
            )
          }

          {labelToUse}
        </ButtonPrimary>
      </Flex>
    </>
  )

  if (isFromProductPage) {
    return (
      <div className='pdp-checkout-button-wrapper'>
        {element}
      </div>
    )
  }

  return (
    <SidebarFooter
      shouldShowAovLock={shouldShowAovLock}
      shouldShowAovUnlock={shouldShowAovUnlock}
    >
      {element}
    </SidebarFooter>
  )
}
